export default __webpack_public_path__ + "static/media/img_recruit_03.55beba4b.png";